import WikiArticlesScreen from "@/src/screens/wiki/wiki-articles-screen/wiki-articles-screen";

export default function WikiArticles() {
  return <WikiArticlesScreen />;
}
